import { Text } from '@noorden-insurtech/alba-design-system';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import type { PmeAnalysisPremium } from '../pme-analysis.mock';

type Props = {
  premium: PmeAnalysisPremium;
  /** Número da cotação exibido no rodapé do card. */
  quoteNumber: string;
  defaultExpanded?: boolean;
};

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className='flex flex-col items-start gap-0.5'>
      <Text className='font-montserrat text-xs text-alba-white-500/80'>
        {label}
      </Text>
      <Text className='font-montserrat text-sm font-bold text-alba-white-500'>
        {value}
      </Text>
    </div>
  );
}

/**
 * Cartão "Prêmio Total" do cabeçalho da Análise PME (mockado).
 * Espelha o layout do Figma: valor total em destaque, uma linha com
 * Prêmio Líquido / IOF / Periodicidade e uma linha com
 * Produto / Tipo de Contratação / Número da Cotação / Status.
 */
export function PmeAnalysisPremiumCard({
  premium,
  quoteNumber,
  defaultExpanded = true,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className='px-8'>
      <div className='relative flex w-full flex-col items-center rounded-2xl bg-linear-to-br from-[#2C285F] to-[#18163D] px-6 py-6 text-center'>
      <button
        type='button'
        onClick={() => setExpanded(prev => !prev)}
        className='absolute right-0 top-0 cursor-pointer border-none bg-transparent px-6 py-4'
        aria-label={expanded ? 'Recolher' : 'Expandir'}
      >
        {expanded ? (
          <ChevronUp className='size-6 text-alba-white-500' />
        ) : (
          <ChevronDown className='size-6 text-alba-white-500' />
        )}
      </button>

      <div className='flex flex-col items-center text-center'>
        <Text className='mb-2 font-montserrat text-sm text-alba-white-500'>
          Prêmio Total
        </Text>
        <Text className='font-montserrat text-3xl font-bold leading-[44px] text-alba-white-500'>
          {premium.totalValue}
        </Text>
      </div>

      {expanded && (
        <>
          <div className='mt-4 grid w-full grid-cols-2 gap-4 sm:grid-cols-3'>
            <Field label='Prêmio Líquido' value={premium.netValue} />
            <Field label='IOF' value={premium.iofValue} />
            <Field
              label='Periodicidade de pagamento'
              value={premium.paymentFrequency}
            />
          </div>

          <div className='mt-4 grid w-full grid-cols-2 gap-4 border-t border-[#9FA4A6] pt-4 sm:grid-cols-4'>
            <Field label='Produto' value={premium.product} />
            <Field label='Tipo de Contratação' value={premium.contractType} />
            <Field label='Número da Cotação' value={quoteNumber} />
            <Field label='Status' value={premium.status} />
          </div>
        </>
      )}
      </div>
    </div>
  );
}
